import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "/api";

const profileService = {
  get: async () => (await axios.get(`${API_URL}/profile`)).data,
  update: async (payload) => (await axios.put(`${API_URL}/profile`, payload)).data,
  changePassword: async (payload) =>
    (await axios.put(`${API_URL}/profile/password`, payload)).data,
  updateNotificationPrefs: async (prefs) =>
    (await axios.put(`${API_URL}/profile/notification-prefs`, { prefs })).data,
  uploadImage: async (formData) =>
    (
      await axios.post(`${API_URL}/profile/image`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
    ).data,

  /* Admin — registration approval */
  listPending: async () =>
    (await axios.get(`${API_URL}/admin/pending-users`)).data,
  countPending: async () =>
    (await axios.get(`${API_URL}/admin/pending-users/count`)).data,
  approveUser: async (userId, payload) =>
    (await axios.post(`${API_URL}/admin/pending-users/${userId}/approve`, payload)).data,
  rejectUser: async (userId) =>
    (await axios.post(`${API_URL}/admin/pending-users/${userId}/reject`)).data,
  getRegistrationAlerts: async () =>
    (await axios.get(`${API_URL}/admin/registration-alerts`)).data,
  updateRegistrationAlerts: async (payload) =>
    (await axios.put(`${API_URL}/admin/registration-alerts`, payload)).data,

  /* Admin — system health */
  getSystemHealth: async () =>
    (await axios.get(`${API_URL}/admin/health/detailed`)).data,
};

export default profileService;